import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const NAV = [
  { to: "/", label: "Inicio", id: "inicio" },
  { to: "/la-cabana", label: "Nosotros", id: "cabana" },
  { to: "/brangus", label: "Brangus", id: "brangus" },
  { to: "/herramientas", label: "Herramientas", id: "herramientas" },
  { to: "/galeria", label: "Galería", id: "galeria" },
  { to: "/catalogo", label: "Catálogo", id: "catalogo" },
  { to: "/premios", label: "Premios", id: "premios" },
  { to: "/contacto", label: "Contacto", id: "contacto" },
];

export const Monogram = ({ className = "" }) => (
  <svg viewBox="0 0 424 371" role="img" aria-label="Logo Hacienda Fernández & Vargas" data-testid="brand-logo-mark"
    className={`h-9 w-11 shrink-0 fill-current text-[#C5A059] ${className}`}>
    <polygon points="0,0 308,0 274,63 112,63 131,101 250,101 212,165 170,165 192,206 156,271" />
    <polygon points="347,0 424,0 212,371 174,306" />
  </svg>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const solid = scrolled || pathname !== "/" || open;

  return (
    <header data-testid="site-header" className={`fixed inset-x-0 top-0 z-40 transition-colors duration-500 ${solid ? "bg-[#1D3324]/95 backdrop-blur-md shadow-lg" : "bg-transparent"}`}>
      <div className="container-fv flex h-20 items-center justify-between text-stone-100">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-3">
          <Monogram />
          <span className="leading-tight">
            <span className="block text-[15px] font-medium tracking-wide">Hacienda Fernández</span>
            <span className="flex items-center gap-2 text-[15px] font-medium tracking-wide"><span className="h-px w-16 bg-[#C5A059]" />&amp; Vargas</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`nav-link-${n.id}`}
              className={({ isActive }) => `text-sm tracking-wide transition-colors hover:text-[#C5A059] ${isActive ? "text-[#C5A059]" : ""}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menú">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden container-fv pb-6 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`nav-mobile-link-${n.id}`}
              className={({ isActive }) => `f-display text-2xl py-2 border-b border-white/10 ${isActive ? "text-[#C5A059]" : "text-stone-100"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
